import successCircle from "../../../assets/svg/implicit_temperature_success.svg";
import failCircle from "../../../assets/svg/implicit_temperature_fail.svg";
import partialCircle from "../../../assets/svg/partial_circle.svg";
import naCircle from "../../../assets/svg/na_circle.svg";
import greenCheckbox from "../../../assets/svg/green_check_box.svg";
import redCheckbox from "../../../assets/svg/red_cross_box.svg";
import partialCheckbox from "../../../assets/svg/partial_checkbox.svg";
import naCheckbox from "../../../assets/svg/na_checkbox.svg";

// NA100 Metrics enum - based on the API data structure
export enum NA100_metrics {
  Indicator_1 = "NA100_Indicator_1",
  Indicator_1_1 = "NA100_Indicator_1_1",
  Indicator_2 = "NA100_Indicator_2",
  Indicator_2_1 = "NA100_Indicator_2_1",
  Indicator_2_2 = "NA100_Indicator_2_2",
  Indicator_2_3 = "NA100_Indicator_2_3",
  Indicator_3 = "NA100_Indicator_3",
  Indicator_3_1 = "NA100_Indicator_3_1",
  Indicator_3_2 = "NA100_Indicator_3_2",
  Indicator_3_3 = "NA100_Indicator_3_3",
  Indicator_4 = "NA100_Indicator_4",
  Indicator_4_1 = "NA100_Indicator_4_1",
  Indicator_4_2 = "NA100_Indicator_4_2",
  Indicator_4_3 = "NA100_Indicator_4_3",
  Indicator_5 = "NA100_Indicator_5",
  Indicator_5_1 = "NA100_Indicator_5_1",
  Indicator_5_2 = "NA100_Indicator_5_2",
  Indicator_5_3 = "NA100_Indicator_5_3",
  Indicator_6 = "NA100_Indicator_6",
  Indicator_6_1 = "NA100_Indicator_6_1",
  Indicator_6_2 = "NA100_Indicator_6_2",
  Indicator_6_3 = "NA100_Indicator_6_3",
  Indicator_6_4 = "NA100_Indicator_6_4",
  // All Metrics
  Metric_1_1_a = "NA100_Metric_1_1_a",
  Metric_1_1_b = "NA100_Metric_1_1_b",
  Metric_2_1_a = "NA100_Metric_2_1_a",
  Metric_2_1_b = "NA100_Metric_2_1_b",
  Metric_2_1_c = "NA100_Metric_2_1_c",
  Metric_2_2_a = "NA100_Metric_2_2_a",
  Metric_2_2_b = "NA100_Metric_2_2_b",
  Metric_2_2_c = "NA100_Metric_2_2_c",
  Metric_2_2_d = "NA100_Metric_2_2_d",
  Metric_2_2_e = "NA100_Metric_2_2_e",
  Metric_2_2_f = "NA100_Metric_2_2_f",
  Metric_2_3_a = "NA100_Metric_2_3_a",
  Metric_2_3_b = "NA100_Metric_2_3_b",
  Metric_3_1_a = "NA100_Metric_3_1_a",
  Metric_3_1_b = "NA100_Metric_3_1_b",
  Metric_3_1_c = "NA100_Metric_3_1_c",
  Metric_3_2_a = "NA100_Metric_3_2_a",
  Metric_3_2_b = "NA100_Metric_3_2_b",
  Metric_3_2_c = "NA100_Metric_3_2_c",
  Metric_3_3_a = "NA100_Metric_3_3_a",
  Metric_4_1_a = "NA100_Metric_4_1_a",
  Metric_4_1_b = "NA100_Metric_4_1_b",
  Metric_4_1_c = "NA100_Metric_4_1_c",
  Metric_4_2_a = "NA100_Metric_4_2_a",
  Metric_4_2_b = "NA100_Metric_4_2_b",
  Metric_4_2_c = "NA100_Metric_4_2_c",
  Metric_4_2_d = "NA100_Metric_4_2_d",
  Metric_4_2_e = "NA100_Metric_4_2_e",
  Metric_4_3_a = "NA100_Metric_4_3_a",
  Metric_4_3_b = "NA100_Metric_4_3_b",
  Metric_5_1_a = "NA100_Metric_5_1_a",
  Metric_5_1_b = "NA100_Metric_5_1_b",
  Metric_5_2_a = "NA100_Metric_5_2_a",
  Metric_5_2_b = "NA100_Metric_5_2_b",
  Metric_5_3_a = "NA100_Metric_5_3_a",
  Metric_5_3_b = "NA100_Metric_5_3_b",
  Metric_5_3_c = "NA100_Metric_5_3_c",
  Metric_6_1_a = "NA100_Metric_6_1_a",
  Metric_6_1_b = "NA100_Metric_6_1_b",
  Metric_6_1_c = "NA100_Metric_6_1_c",
  Metric_6_1_d = "NA100_Metric_6_1_d",
  Metric_6_2_a = "NA100_Metric_6_2_a",
  Metric_6_2_b = "NA100_Metric_6_2_b",
  Metric_6_2_c = "NA100_Metric_6_2_c",
  Metric_6_2_d = "NA100_Metric_6_2_d",
  Metric_6_3_a = "NA100_Metric_6_3_a",
  Metric_6_3_b = "NA100_Metric_6_3_b",
  Metric_6_4_a = "NA100_Metric_6_4_a",
  Metric_6_4_b = "NA100_Metric_6_4_b",
  Metric_6_4_c = "NA100_Metric_6_4_c",
}

export type FormattedNA100Metric<T extends NA100_metrics> = {
  value: string;
  metricId: T;
  metricName: string;
  metricDescription: string;
};

export const NA100_metricLevels: Record<NA100_metrics, number> = {
  // Indicator 1
  [NA100_metrics.Indicator_1]: 1,
  [NA100_metrics.Indicator_1_1]: 2,
  [NA100_metrics.Metric_1_1_a]: 3,
  [NA100_metrics.Metric_1_1_b]: 3,

  // Indicator 2
  [NA100_metrics.Indicator_2]: 1,
  [NA100_metrics.Indicator_2_1]: 2,
  [NA100_metrics.Metric_2_1_a]: 3,
  [NA100_metrics.Metric_2_1_b]: 3,
  [NA100_metrics.Metric_2_1_c]: 3,
  [NA100_metrics.Indicator_2_2]: 2,
  [NA100_metrics.Metric_2_2_a]: 3,
  [NA100_metrics.Metric_2_2_b]: 3,
  [NA100_metrics.Metric_2_2_c]: 3,
  [NA100_metrics.Metric_2_2_d]: 3,
  [NA100_metrics.Metric_2_2_e]: 3,
  [NA100_metrics.Metric_2_2_f]: 3,
  [NA100_metrics.Indicator_2_3]: 2,
  [NA100_metrics.Metric_2_3_a]: 3,
  [NA100_metrics.Metric_2_3_b]: 3,

  // Indicator 3
  [NA100_metrics.Indicator_3]: 1,
  [NA100_metrics.Indicator_3_1]: 2,
  [NA100_metrics.Metric_3_1_a]: 3,
  [NA100_metrics.Metric_3_1_b]: 3,
  [NA100_metrics.Metric_3_1_c]: 3,
  [NA100_metrics.Indicator_3_2]: 2,
  [NA100_metrics.Metric_3_2_a]: 3,
  [NA100_metrics.Metric_3_2_b]: 3,
  [NA100_metrics.Metric_3_2_c]: 3,
  [NA100_metrics.Indicator_3_3]: 2,
  [NA100_metrics.Metric_3_3_a]: 3,

  // Indicator 4
  [NA100_metrics.Indicator_4]: 1,
  [NA100_metrics.Indicator_4_1]: 2,
  [NA100_metrics.Metric_4_1_a]: 3,
  [NA100_metrics.Metric_4_1_b]: 3,
  [NA100_metrics.Metric_4_1_c]: 3,
  [NA100_metrics.Indicator_4_2]: 2,
  [NA100_metrics.Metric_4_2_a]: 3,
  [NA100_metrics.Metric_4_2_b]: 3,
  [NA100_metrics.Metric_4_2_c]: 3,
  [NA100_metrics.Metric_4_2_d]: 3,
  [NA100_metrics.Metric_4_2_e]: 3,
  [NA100_metrics.Indicator_4_3]: 2,
  [NA100_metrics.Metric_4_3_a]: 3,
  [NA100_metrics.Metric_4_3_b]: 3,

  // Indicator 5
  [NA100_metrics.Indicator_5]: 1,
  [NA100_metrics.Indicator_5_1]: 2,
  [NA100_metrics.Metric_5_1_a]: 3,
  [NA100_metrics.Metric_5_1_b]: 3,
  [NA100_metrics.Indicator_5_2]: 2,
  [NA100_metrics.Metric_5_2_a]: 3,
  [NA100_metrics.Metric_5_2_b]: 3,
  [NA100_metrics.Indicator_5_3]: 2,
  [NA100_metrics.Metric_5_3_a]: 3,
  [NA100_metrics.Metric_5_3_b]: 3,
  [NA100_metrics.Metric_5_3_c]: 3,

  // Indicator 6
  [NA100_metrics.Indicator_6]: 1,
  [NA100_metrics.Indicator_6_1]: 2,
  [NA100_metrics.Metric_6_1_a]: 3,
  [NA100_metrics.Metric_6_1_b]: 3,
  [NA100_metrics.Metric_6_1_c]: 3,
  [NA100_metrics.Metric_6_1_d]: 3,
  [NA100_metrics.Indicator_6_2]: 2,
  [NA100_metrics.Metric_6_2_a]: 3,
  [NA100_metrics.Metric_6_2_b]: 3,
  [NA100_metrics.Metric_6_2_c]: 3,
  [NA100_metrics.Metric_6_2_d]: 3,
  [NA100_metrics.Indicator_6_3]: 2,
  [NA100_metrics.Metric_6_3_a]: 3,
  [NA100_metrics.Metric_6_3_b]: 3,
  [NA100_metrics.Indicator_6_4]: 2,
  [NA100_metrics.Metric_6_4_a]: 3,
  [NA100_metrics.Metric_6_4_b]: 3,
  [NA100_metrics.Metric_6_4_c]: 3,
};

export interface NA100TreeNode {
  id: NA100_metrics;
  children?: NA100TreeNode[];
}

// Tree structure for NA100 metrics
export const NA100_TREE: NA100TreeNode[] = [
  // Indicator 1: Ambition
  {
    id: NA100_metrics.Indicator_1,
    children: [
      {
        id: NA100_metrics.Indicator_1_1,
        children: [
          { id: NA100_metrics.Metric_1_1_a },
          { id: NA100_metrics.Metric_1_1_b },
        ],
      },
    ],
  },

  // Indicator 2: Assessment
  {
    id: NA100_metrics.Indicator_2,
    children: [
      {
        id: NA100_metrics.Indicator_2_1,
        children: [
          { id: NA100_metrics.Metric_2_1_a },
          { id: NA100_metrics.Metric_2_1_b },
          { id: NA100_metrics.Metric_2_1_c },
        ],
      },
      {
        id: NA100_metrics.Indicator_2_2,
        children: [
          { id: NA100_metrics.Metric_2_2_a },
          { id: NA100_metrics.Metric_2_2_b },
          { id: NA100_metrics.Metric_2_2_c },
          { id: NA100_metrics.Metric_2_2_d },
          { id: NA100_metrics.Metric_2_2_e },
          { id: NA100_metrics.Metric_2_2_f },
        ],
      },
      {
        id: NA100_metrics.Indicator_2_3,
        children: [
          { id: NA100_metrics.Metric_2_3_a },
          { id: NA100_metrics.Metric_2_3_b },
        ],
      },
    ],
  },

  // Indicator 3: Targets
  {
    id: NA100_metrics.Indicator_3,
    children: [
      {
        id: NA100_metrics.Indicator_3_1,
        children: [
          { id: NA100_metrics.Metric_3_1_a },
          { id: NA100_metrics.Metric_3_1_b },
          { id: NA100_metrics.Metric_3_1_c },
        ],
      },
      {
        id: NA100_metrics.Indicator_3_2,
        children: [
          { id: NA100_metrics.Metric_3_2_a },
          { id: NA100_metrics.Metric_3_2_b },
          { id: NA100_metrics.Metric_3_2_c },
        ],
      },
      {
        id: NA100_metrics.Indicator_3_3,
        children: [{ id: NA100_metrics.Metric_3_3_a }],
      },
    ],
  },

  // Indicator 4: Implementation
  {
    id: NA100_metrics.Indicator_4,
    children: [
      {
        id: NA100_metrics.Indicator_4_1,
        children: [
          { id: NA100_metrics.Metric_4_1_a },
          { id: NA100_metrics.Metric_4_1_b },
          { id: NA100_metrics.Metric_4_1_c },
        ],
      },
      {
        id: NA100_metrics.Indicator_4_2,
        children: [
          { id: NA100_metrics.Metric_4_2_a },
          { id: NA100_metrics.Metric_4_2_b },
          { id: NA100_metrics.Metric_4_2_c },
          { id: NA100_metrics.Metric_4_2_d },
          { id: NA100_metrics.Metric_4_2_e },
        ],
      },
      {
        id: NA100_metrics.Indicator_4_3,
        children: [
          { id: NA100_metrics.Metric_4_3_a },
          { id: NA100_metrics.Metric_4_3_b },
        ],
      },
    ],
  },

  // Indicator 5: Governance
  {
    id: NA100_metrics.Indicator_5,
    children: [
      {
        id: NA100_metrics.Indicator_5_1,
        children: [
          { id: NA100_metrics.Metric_5_1_a },
          { id: NA100_metrics.Metric_5_1_b },
        ],
      },
      {
        id: NA100_metrics.Indicator_5_2,
        children: [
          { id: NA100_metrics.Metric_5_2_a },
          { id: NA100_metrics.Metric_5_2_b },
        ],
      },
      {
        id: NA100_metrics.Indicator_5_3,
        children: [
          { id: NA100_metrics.Metric_5_3_a },
          { id: NA100_metrics.Metric_5_3_b },
          { id: NA100_metrics.Metric_5_3_c },
        ],
      },
    ],
  },

  // Indicator 6
  {
    id: NA100_metrics.Indicator_6,
    children: [
      {
        id: NA100_metrics.Indicator_6_1,
        children: [
          { id: NA100_metrics.Metric_6_1_a },
          { id: NA100_metrics.Metric_6_1_b },
          { id: NA100_metrics.Metric_6_1_c },
          { id: NA100_metrics.Metric_6_1_d },
        ],
      },
      {
        id: NA100_metrics.Indicator_6_2,
        children: [
          { id: NA100_metrics.Metric_6_2_a },
          { id: NA100_metrics.Metric_6_2_b },
          { id: NA100_metrics.Metric_6_2_c },
          { id: NA100_metrics.Metric_6_2_d },
        ],
      },
      {
        id: NA100_metrics.Indicator_6_3,
        children: [
          { id: NA100_metrics.Metric_6_3_a },
          { id: NA100_metrics.Metric_6_3_b },
        ],
      },
      {
        id: NA100_metrics.Indicator_6_4,
        children: [
          { id: NA100_metrics.Metric_6_4_a },
          { id: NA100_metrics.Metric_6_4_b },
          { id: NA100_metrics.Metric_6_4_c },
        ],
      },
    ],
  },
];

export enum Na100IndicatorValue {
  Yes = "Yes",
  No = "No",
  Partial = "Partial",
  NotRelevant = "Not Relevant",
  NotAvailable = "Not Available",
  NA = "-",
}

export const NA100_VALUE_MAP: Record<Na100IndicatorValue, string> = {
  [Na100IndicatorValue.Yes]: successCircle,
  [Na100IndicatorValue.No]: failCircle,
  [Na100IndicatorValue.Partial]: partialCircle,
  [Na100IndicatorValue.NotRelevant]: naCircle,
  [Na100IndicatorValue.NotAvailable]: naCircle,
  [Na100IndicatorValue.NA]: naCircle,
};

export const NA100_VALUE_MAP_TOP_LEVEL: Record<Na100IndicatorValue, string> = {
  [Na100IndicatorValue.Yes]: greenCheckbox,
  [Na100IndicatorValue.No]: redCheckbox,
  [Na100IndicatorValue.Partial]: partialCheckbox,
  [Na100IndicatorValue.NotRelevant]: naCheckbox,
  [Na100IndicatorValue.NotAvailable]: naCheckbox,
  [Na100IndicatorValue.NA]: naCheckbox,
};
